var exports = {
  "kL": "xdbfd91f1--38f8cf--container",
  "rA": "xdbfd91f1--38f8cf--mobile_container",
  "p_": "xdbfd91f1--38f8cf--list",
  "QP": "xdbfd91f1--38f8cf--mobile_list",
  "DD": "xdbfd91f1--38f8cf--title",
  "CL": "xdbfd91f1--38f8cf--mobile_title",
};

module.exports = exports;
